export const GET_ORDER_HISTORY_OF_MERCHANT_REQUEST =
  'GET_ORDER_HISTORY_OF_MERCHANT_REQUEST';
export const GET_ORDER_HISTORY_OF_MERCHANT_SUCCESS =
  'GET_ORDER_HISTORY_OF_MERCHANT_SUCCESS';
export const GET_ORDER_HISTORY_OF_MERCHANT_FAILURE =
  'GET_ORDER_HISTORY_OF_MERCHANT_FAILURE';
